module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"50","height":"50","viewBox":"0 0 50 50"},"content":"<path fill=\"#FF4A4A\" class='channel-icon-logo'  fill-rule=\"evenodd\" d=\"M25.281 21.04v7.92s7.792-.01 10.965-.01c-1.718 5.135-4.39 7.931-10.965 7.931-6.654 0-11.847-5.32-11.847-11.881 0-6.562 5.193-11.881 11.847-11.881 3.518 0 5.79 1.22 7.874 2.919 1.669-1.645 1.53-1.88 5.774-5.832A20.366 20.366 0 0 0 25.28 5C14.081 5 5 13.954 5 25s9.08 20 20.281 20c16.743 0 20.835-14.376 19.478-23.96H25.281z\"/>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/channel/google.svg
// module id = 1306
// module chunks = 0